import { useAvailabilityIndex } from './search/useAvailabilityIndex';
import { useFilteredProperties } from './search/useFilteredProperties';
import { usePropertiesData } from './search/usePropertiesData';
import { useSearchAnalytics } from './search/useSearchAnalytics';
import { useSearchParamsState } from './search/useSearchParamsState';

export interface UseSearchResultsOptions {
  optimized?: boolean;
  enableAnalytics?: boolean;
  debounceDelay?: number;
  guestsCompare?: 'maxCapacity' | 'lte';
}

export const useSearchResults = (opts: UseSearchResultsOptions = {}) => {
  const {
    optimized = true,
    enableAnalytics = true,
    debounceDelay = 300,
    guestsCompare = 'maxCapacity',
  } = opts;

  const {
    guestsRaw,
    checkinRaw,
    checkoutRaw,
    guests,
    checkInDate,
    checkOutDate,
  } = useSearchParamsState(debounceDelay);

  const {
    availableProperties,
    propertyIds,
    isLoading: propertiesLoading,
    error: propertiesError,
  } = usePropertiesData();

  const {
    availability,
    anyLoading: availabilityLoading,
    hasErrors: availabilityErrors,
    snapshot,
  } = useAvailabilityIndex(propertyIds);

  const { filtered, allAvailabilityReady } = useFilteredProperties({
    availableProperties,
    propertyIds,
    availability,
    checkInDate,
    checkOutDate,
    guestCount: guests,
    snapshot,
    optimized,
    guestsCompare,
  });

  const isAnyLoading = propertiesLoading || availabilityLoading;
  useSearchAnalytics({
    enable: enableAnalytics,
    guests: guestsRaw,
    checkin: checkinRaw,
    checkout: checkoutRaw,
    isLoading: isAnyLoading,
    resultsCount: filtered.length,
  });

  const hasErrors = !!propertiesError || availabilityErrors;

  const refetchAll = () => {
    console.log('Search results refetch triggered');
  };

  return {
    filteredProperties: filtered,
    isAnyLoading,
    hasErrors,
    refetchAll,
    guests: guestsRaw,
    checkin: checkinRaw,
    checkout: checkoutRaw,
    allAvailabilityReady,
  };
};
